import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemBodyStyled = styled(Text)`
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
  overflow-wrap: anywhere;
`
